export const FILES_UPLOAD_START = 'FILES_UPLOAD_START';
export const FILES_UPLOAD_UPDATE_STATUS = 'FILES_UPLOAD_UPDATE_STATUS';
export const FILES_UPLOAD_UPDATE_FINISH = 'FILES_UPLOAD_UPDATE_FINISH';
export const FILES_UPLOAD_UPDATE_ERROR = 'FILES_UPLOAD_UPDATE_ERROR';
export const FILES_UPLOAD_MAX_QUEUE = 'FILES_UPLOAD_MAX_QUEUE';
export const FILES_FREE_SPACE_GET = 'FILES_FREE_SPACE_GET';
export const FILES_UPLOAD_HIDE_ERROR = 'FILES_UPLOAD_HIDE_ERROR';
export const FILES_UPLOAD_UPDATE_RESET = 'FILES_UPLOAD_UPDATE_RESET';